import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Tablets: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '7', cy: '7', r: '5' }],
    ['circle', { cx: '17', cy: '17', r: '5' }],
    ['path', { d: 'M12 17h10' }],
    ['path', { d: 'm3.46 10.54 7.08-7.08' }],
  ],
];

export default Tablets;
